import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, invalid, ...props }, ref) => (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'flex h-11 w-full rounded-md border bg-(--color-surface) px-3 text-sm text-(--color-fg) placeholder:text-(--color-fg-muted) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--color-accent) disabled:cursor-not-allowed disabled:opacity-50',
        invalid ? 'border-(--color-error)' : 'border-(--color-border)',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
